import type { StatsConfig } from '@/components/composite/MediaViewer/components/MediaViewerStats/types';

import { SIZE_FULL } from '@/lib/gridElements/size';

import VideoViewsQuartileChart from '@/components/composite/MediaViewer/charts/VideoViewsQuartileChart';

/**
 * Video Views Quartile Chart Configuration for Media Viewer
 *
 * Displays a horizontal bar chart showing video playback completion rates:
 * - playback_0_count: Views that started (0%)
 * - playback_25_count: Views that reached 25%
 * - playback_50_count: Views that reached 50%
 * - playback_75_count: Views that reached 75%
 * - playback_100_count: Views that completed (100%)
 *
 * Data source: includes.media.non_public_metrics.*
 */
export const mediaViewerVideoViewsQuartileConfig: StatsConfig & { title: string; icon: string } = {
    id: 'video_views_quartile',
    type: 'chart',
    size: SIZE_FULL,
    element: VideoViewsQuartileChart,
    title: 'kpi.twitter.mediaviewer.video_views_quartile',
    icon: 'video'
};
